import styles from "./Footer.module.css";

function Footer({ className }) {
  return (
    <footer className={`${styles.footer} ${className ?? ""}`}>
      <p className={styles.copyright}>&copy; NESTOCK Co., Ltd</p>
    </footer>
  );
}

export default Footer;
